import { Component, OnInit, Inject } from '@angular/core';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { FlightStatusService } from '@modules/flight-status/flight-status.service';
import { DataCollectionClientService } from '@core/services/data-collection-client.service';
@Component({
    selector: 'hp-flight-status',
    templateUrl: './flight-status.component.html',
    styleUrls: ['./flight-status.component.scss']
})
export class FlightStatusComponent implements OnInit {
    labelsInitialized: boolean;
    showLoading = false;
    homepageURI = '/homePage.do';
    flightStatusURI= '/travelInformation/flights/status';

    constructor(@Inject(I18NEXT_SERVICE) private _i18NextService: ITranslationService,
        private _flightStatusService: FlightStatusService,
        private _dataCollectionClient: DataCollectionClientService
    ) {
    }

    ngOnInit(): void {
        const self = this;
        this._i18NextService.events.initialized.subscribe(data => {
            if (data) {
                this._flightStatusService.loadNamespaces().then(() => {
                    this.labelsInitialized = true
                });
            }
        });
        this._dataCollectionClient.loadScript()
        .then(() => {
            const initDCFData = {
                page_name: 'Flight Status Webcomponent',
                channel: 'Homepage'
            };

            window.addEventListener('load', function () {

                const location: String = this.window.location.href;
                let dcfCreated = false;
                const flightStatusTab = document.getElementById('jq-flightStatus');
                flightStatusTab?.addEventListener('click', () => {
                    if (!dcfCreated) {
                        self._dataCollectionClient.initAnalytics(initDCFData, 'Initial Call', 'link');
                        dcfCreated = true;
                    }
                });

                if (location.includes(self.homepageURI)) {
                    let dcfCreated = false;
                    const flightStatusTab = document.getElementById('jq-flightStatus');
                    flightStatusTab?.addEventListener('click', () => {
                        if (!dcfCreated) {
                            self._dataCollectionClient.initAnalytics(initDCFData, 'Initial Call', 'view');
                            dcfCreated = true;
                        }
                    });
                } else if (location.includes(self.flightStatusURI)) {
                    self._dataCollectionClient.initAnalytics(initDCFData, 'Initial Call', 'view');
                }
            }, false);
        });
    }

    loadingChangedHandler(loadingState: boolean) {
        this.showLoading = loadingState;
    }
}
